import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../../../hooks/useGraphQLMutation.hook';

export const ThirdPartyForm_Address_Remove_Mutation = graphql(`
  mutation ThirdPartyForm_Address_Remove(
    $addressId: Id!
    $thirdPartyId: Id!
    $versionData: VersionDataInput
  ) {
    removeThirdPartyAddress(
      addressId: $addressId
      multiAddressableId: $thirdPartyId
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export const useRemoveThirdPartyAddressMutation = () =>
  useGraphQLMutation(ThirdPartyForm_Address_Remove_Mutation);
